<template>
  <div
    class="flex flex-col rounded-md border shadow-main"
    :class="[{ 'grow bg-white': !isSms }]"
  >
    <slot name="content" />
    <div
      class="log-footer flex items-center justify-between space-x-4 p-4 shadow-sm"
    >
      <slot name="footer" />
    </div>
    <log-comments-section
      v-if="showComments && !disableComments"
      ref="logCommentsSectionRef"
      :comments="comments ?? []"
      :is-sms="isSms"
    />
  </div>
</template>

<script lang="ts" setup>
import { nextTick, ref, useTemplateRef } from "vue";

import { TOGGLE_COMMENTS } from "@/helpers/constants/events";
import { useEmitter } from "@/hooks/common";

import LogCommentsSection from "@/components/communicationLogs/comments/LogCommentsSection.vue";

import type { CommunicationLogComment } from "@/models/communicationLogs";

defineProps<{
  title?: string;
  backgroundClass?: string;
  comments?: CommunicationLogComment[];
  disableComments?: boolean;
  isSms?: boolean;
}>();

const emitter = useEmitter();

const showComments = ref(false);

const logCommentsSectionRef = useTemplateRef("logCommentsSectionRef");

emitter.on(TOGGLE_COMMENTS, async () => {
  showComments.value = !showComments.value;
  if (showComments.value) {
    await nextTick();
    logCommentsSectionRef.value?.$el?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.log-footer {
  container-type: inline-size;
  container-name: log-footer;
}

@container log-footer (min-width: 750px) {
  :deep() {
    .wrapper {
      @apply space-x-2;
    }
  }
}

@container log-footer (max-width: 750px) {
  :deep() {
    .wrapper,
    .wrap-children {
      @apply -mr-1 -ml-1 flex-wrap;
      > div {
        @apply p-1;
      }
    }
  }
}
</style>
